export default __webpack_public_path__ + "static/media/log.30bd11f1.png";